<template>
  <router-view :project-settings="projectSettings"></router-view>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: "generic-projects",
  
  computed: {
    ...mapState({
      projectSettings: state => state.projects.projectSettings.data
    })
  },
  
  watch: {
    '$route.params.project_id': {
      immediate: true,
      handler(projectId) {
        if (projectId) {
          this.loadProjectSettings(projectId);
        }
      }
    }
  },
  
  methods: {
    ...mapActions({
      getProjectSettings: 'projects/getProjectSettings'
    }),
    
    loadProjectSettings(projectId) {
      this.getProjectSettings({ projectId }).catch(err => {
        console.error('Failed to load project settings:', err);
      });
    }
  }
}
</script>